<template>
	<div>
		<form-sidebar>
			<v-form>
				<v-layout wrap>
					<v-flex xs12 pl-2>
						<p class="mb-1 caption">Tipo</p>
						<p>{{ dataType === 1 ? 'Cabecera' : 'Detalle' }}</p>
					</v-flex>
					<v-flex xs12>
						<BaseInput 
							:height="38"
							label="Código"
							v-model="$v.model.code.$model"
							required
						/>
					</v-flex>
					<v-flex xs12>
						<BaseInput
						:height="38"
						label="Nombre"
						v-model="$v.model.name.$model"
						/>
					</v-flex>
					<v-flex xs12>
						<BaseInput 
						:height="38"
						label="Descripción"
						v-model="model.description"
						/>
					</v-flex>
					<v-flex xs12>
						<BaseInput
						:height="38"
						label="Data de ejemplo"
						v-model="model.example"
						/>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						@cancel-button-clicked="$emit('close-modal')"
						@accept-button-clicked="submitForm"
						:is-loading="disableButton"
					>
					</modal-sidebar-button>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>

import { required } from 'vuelidate/lib/validators';
import BaseInput from '@/components/shared/inputs/base-input';
import BaseSelect from '@/components/shared/inputs/base-select';

function data() {
	return {
		isLoading: false,
		model: {
			code: '',
			description: '',
			example: '',
			moduleId: null,
			name: '',
		},
		modules: [],
	};
}

function createDictionaryModel({ dataType, model, subsidiaryModuleId, isEditing }) {
	const newDefinition = {
		name: model.name,
		code: model.code,
		dataType,
		description: model.description,
		example: model.example,
	};
	if (!isEditing) {
		newDefinition.subsidiaryModuleId = subsidiaryModuleId;
	}
	return newDefinition;
}

async function created() {
	const requests = [];
	if (this.mode.isEditing) {
		requests.push(this.$http.get(`data-dictionary/${this.id}`));
	}
	const [model] = await Promise.all(requests);
	if (model) {
		this.model = {
			code: model.data.code,
			name: model.data.name,
			description: model.data.description,
			example: model.data.example,
			subsidiaryModuleId: model.data.subsidiaryModuleId,
		};
	}
}

function disableButton() {
	return this.$v.$invalid || this.loading;
}

function mode() {
	const isEditing = Boolean(this.id);
	return {
		isEditing,
		method: isEditing ? 'patch' : 'post',
		message: isEditing ? 'actualizado' : 'registrado',
		url: isEditing ? `data-dictionary/${this.id}` : 'data-dictionary',
	};
}

async function submitForm() {
	this.isLoading = true;
	const dictionary = createDictionaryModel({
		model: this.model,
		dataType: this.dataType,
		isEditing: this.mode.isEditing,
		subsidiaryModuleId: this.subsidiaryModuleId,
	});
	try {
		await this.$http[this.mode.method](this.mode.url, dictionary);
		this.$emit('close-modal', true);
		this.showNotification(`Dato ${this.mode.message} correctamente`);
	} catch (error) {
		if (error.status === 500) {
			this.showGenericError();
		} else if (error.status === 400) {
			if (error.data.message === 'DICTIONARY_CODE_WITH_SPACES') {
				this.showGenericError('El código del dato no debe tener espacios. Ejemplo: myCode');
			}
		}
	} finally {
		this.isLoading = false;
	}
}

function validations() {
	const validation = {
		model: {
			name: {
				required,
			},
			code: {
				required,
			},
		},
	};
	return validation;
}

export default {
	name: 'dictionary-form',
	created,
	computed: {
		disableButton,
		mode,
	},
	components: {
		BaseInput,
		BaseSelect,
	},
	data,
	methods: {
		submitForm,
	},
	props: {
		dataType: {
			type: Number,
			required: true,
		},
		subsidiaryModuleId: {
			type: Number,
			required: true,
		},
		id: {
			type: Number,
			default: null,
		},
	},
	validations,
};
</script>
<style lang="scss" scoped>
.caption {
	color: map-get($colors, grey-text);
	font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/dictionary-form.vue